// Site Configuration
export const SITE_CONFIG = {
  name: 'Elowen IT',
  tagline: 'Powering Your Growth with Modern IT Solutions',
  description: 'Dependable IT Managed Services, SOC Operations, Resource Outsourcing, and AI Adoption Advisory.',
};

// Contact Information
export const CONTACT_INFO = {
  email: 'info-sales@elowenit.com',
  phone: '+91-9686189580',
  address: '',
};

// Social Media Links
export const SOCIAL_LINKS = {
  linkedin: '#',
  twitter: '#',
  instagram: '#',
  facebook: '#',
};

// Navigation Links
export const NAV_LINKS = [
  { href: '/', label: 'Home' },
  { href: '/services', label: 'Services' },
  { href: '/about', label: 'About Us' },
  { href: '/#contact', label: 'Contact Us' },
];

// Services Data
export const SERVICES = [
  {
    id: 1,
    title: 'Professional Services',
    description: 'Expert professional services tailored to drive business success and strategic growth.',
    image: '/hero-bg.jpg',
  },
  {
    id: 2,
    title: 'IT Infrastructure',
    description: 'Comprehensive managed IT and infrastructure services to optimize and secure your business operations.',
    image: '/hero-bg.jpg',
  },
  {
    id: 3,
    title: 'Managed Security',
    description: 'Robust managed security services to protect your business from evolving cyber threats.',
    image: '/hero-bg.jpg',
  },
];

// Features for Why Choose Us
export const FEATURES = [
  { id: 1, title: 'Scalable Solutions for any Business Size', iconPosition: 'right', row: 1 },
  { id: 2, title: 'Focus on ROI and Business Outcome', iconPosition: 'right', row: 1 },
  { id: 3, title: 'Customized AI Roadmaps', iconPosition: 'right', row: 1 },
  { id: 4, title: 'Hands-on Implementation Support', iconPosition: 'left', row: 2 },
  { id: 5, title: 'Expert Teams in AI Technologies and Trends', iconPosition: 'left', row: 2 },
];

// Testimonials
export const TESTIMONIALS = [
  {
    id: 1,
    quote: "Working with ElowenIT to build our travel booking website was a game-changer for our business. They understood our vision perfectly and delivered a professional, user-friendly platform that increased our online footprints by 150% within the first three months. Their expertise in travel industry solutions and ongoing support has made all the difference in helping us compete with the big players in online travel.",
    name: 'VIPIN',
    company: 'GAMATHTRAVEL',
    role: 'FOUNDER & CEO',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100',
  },
  {
    id: 2,
    quote: "ElowenIT transformed our cybersecurity infrastructure and guided us through SOC 2, ISO 27001, and industry compliance requirements with exceptional expertise. We achieved green signals on all major compliance frameworks, impressing our auditors with comprehensive security controls and documentation. Their 24/7 monitoring and responsive support provide enterprise-level protection—I highly recommend them to any organization seeking cybersecurity excellence and regulatory compliance.",
    name: 'VISHAL',
    company: 'BRISKK',
    role: 'CO-FOUNDER',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100',
  },
  {
    id: 3,
    quote: "With Elowen's resource outsourcing model, we reduced hiring costs and onboarded trained talent in record time. Their people are dependable, proactive, and always deliver. The Elowen People program allowed us to focus on strategy while their experts handled day-to-day IT execution. Their ability to upskill talent as we grew was invaluable.",
    name: 'P MOHANTY',
    company: 'INTELLIROOT',
    role: 'FOUNDER',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100',
  },
  {
    id: 4,
    quote: "Elowen delivered exceptional talent and flawless project execution for our AI and cloud modernization initiative, providing skilled developers proficient in cutting-edge technologies like React, Node.js, and AWS serverless architecture. Their team seamlessly integrated with our existing workforce and delivered our complex microservices migration while maintaining zero downtime. The quality of their staffing and their ability to execute projects using the latest technology stack has made them our go-to partner for all critical technology initiatives.",
    name: 'INVINCIONE',
    company: 'INVINCIONE',
    role: 'Modernized Tech Solution',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100',
  },
];

// Hero Tags
export const HERO_TAGS = [
  'IT Services',
  'Security Solutions',
  'Cloud & DevOps',
];

// Footer Links
export const FOOTER_NAVIGATION = [
  { href: '#about', label: 'About Us' },
  { href: '#services', label: 'Services' },
  { href: '#', label: 'Our Clients' },
  { href: '#contact', label: 'Contact Us' },
];

export const FOOTER_SERVICES = [
  { href: '#', label: 'Managed IT and Infra Services' },
  { href: '#', label: 'Managed Security Services' },
  { href: '#', label: 'Professional Services' },
];

// EmailJS Configuration (replace placeholders with your actual IDs)
export const EMAILJS_CONFIG = {
  serviceId: 'service_krbphgu',
  templateId: 'template_y06gwzm',
  publicKey: 'H-DvMU2E918XgPePU',
};
